import { useId } from "react";
import { toast } from "sonner";
import { isAllowedMemberColor, normalizeHexColor, resolveMemberColor } from "../lib/memberColors";

/** Single circle — native colour input overlaid for reliable mobile taps. */
export function MemberColorPicker({ value, onChange, label = "Member colour", testId }) {
    const inputId = useId();
    const color = resolveMemberColor(value);

    const handleChange = (next) => {
        if (!isAllowedMemberColor(next)) {
            toast.error("Choose a brighter colour", {
                description: "Very dark colours are hard to see on the split wheel.",
            });
            return;
        }
        onChange(normalizeHexColor(next));
    };

    return (
        <div className="member-color-picker" style={{ "--member-color": color }} data-testid={testId}>
            <span
                className="member-color-btn"
                style={{ backgroundColor: color }}
                aria-hidden="true"
            />
            <input
                id={inputId}
                type="color"
                value={color}
                onChange={(e) => handleChange(e.target.value)}
                className="member-color-btn__native"
                aria-label={`${label}: ${color}. Open colour picker`}
                data-testid={testId ? `${testId}-trigger` : undefined}
            />
        </div>
    );
}
